import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel'
import { styled } from '@mui/material'

export const StyledCarousel = styled(ResponsiveCarousel)({
  '& .slider li': {
    textAlign: 'left',
  },
})
